"use client";
import { FellouButton } from "@/ui-components-next/FellouButton";
import classNames from "classnames";
import { useRouter } from "next/navigation";
import { onLogin, logout } from "@/utils";
import { useEffect, useContext, FC, useCallback, useState } from "react";
import { menuList } from "@/components/MobileHeader/customerList";
import { handleScroll } from "@/utils";
import { ScrollTypeEnum } from "@/components/CommonLayout/constants";
import { WebsiteContext, WebsiteContextKey } from "@/components/CommonLayout/WebsiteContext";
import "./styles.scss";

export interface MobileTopDownMenuProps {
  visible: boolean;
  onClose: () => void;
}

export const MobileTopDownMenu: FC<MobileTopDownMenuProps> = ({ visible, onClose }) => {
  const { onSaveWebsiteCallback } = useContext(WebsiteContext);
  const [userInfo, setUserInfo] = useState<any>(null);
  const router = useRouter();
  useEffect(() => {
    if (visible) {
      document.body.style.overflow = "hidden";
      document.body.style.touchAction = "none";
    } else {
      document.body.style.overflow = "";
      document.body.style.touchAction = "";
    }
  }, [visible]);

  const getUserInfo = useCallback(async () => {
    const userInfo = localStorage.getItem("fellou.userInfo");
    if (userInfo) {
      setUserInfo(JSON.parse(userInfo));
    }
  }, []);

  useEffect(() => {
    getUserInfo();
  }, []);

  useEffect(() => {
    const handleLoginSuccess = (e: CustomEvent) => {
      if (e.detail) {
        getUserInfo();
      }
    };
    window.addEventListener("login_success", handleLoginSuccess as EventListener);
    return () => {
      window.removeEventListener("login_success", handleLoginSuccess as EventListener);
    };
  }, []);

  return (
    <div className={classNames("fellou-mb-top-menu", { "fellou-mb-top-menu-visible": visible })}>
      <div className={"header-menu"}>
        {menuList.map((item, index) => {
          return (
            <div
              className="menu-item cursor-pointer"
              key={`menu-item-${index}`}
              onClick={() => {
                if (item.href === "/" || item.href === "/use-cases/") {
                  router.push(item.href);
                  onClose?.();
                } else if (item.key === "developer") {
                  handleScroll(ScrollTypeEnum.DEVELOP_SCREEN_ID);
                } else {
                  window.open(item.href, "_blank");
                }
              }}
            >
              {item.title}
              <i className="icon iconfont icon-a-arrow-right-s-line1"></i>
            </div>
          );
        })}
      </div>
      <div className="fellou-mb-top-menu-btn">
        {!userInfo ? (
          <FellouButton
            mode="dominant-color"
            className="home-header-btn"
            onClick={() => {
              onLogin();
              onClose?.();
            }}
          >
            Log in
          </FellouButton>
        ) : (
          <FellouButton
            mode="white-border-transparent-bg"
            className="home-header-btn consult-logout-btn"
            onClick={() => {
              logout();
              onClose?.();
            }}
          >
            Log out
          </FellouButton>
        )}
      </div>
    </div>
  );
};
